import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { initTraceUp } from '@/utils/traceup/traceup';
import { reloadOnceForStaleChunk } from '@/utils/staleChunkReload';

// Spec 027 — captura de errores globales (window.error / unhandledrejection).
// No-op salvo que VITE_TRACEUP_ENABLED=true y haya hash.
initTraceUp();

// Chunk obsoleto tras deploy: Vite emite 'vite:preloadError' cuando falla la
// precarga de un chunk/CSS dinámico (hash viejo borrado por el deploy). Se
// recarga una sola vez para traer los assets vigentes (guard anti-bucle).
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadOnceForStaleChunk();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
